import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import DataParser from "../../utlits/Dataparser";
import UserProfile from "../Reuseable/UserProfile.";
import Notofication from "../Reuseable/Notofication";
import QuickNote from "../Reuseable/QuickNote";
import OpenMeetingReminder from "../Reuseable/OpenMeetingReminder";
import MeetingOverrunPrompt from "../Reuseable/MeetingOverrunPrompt";
import LoginService from "../../Services/LoginService";
import NotificationBanner from "./NotificationBanner";


const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return "Good morning";
  if (hour >= 12 && hour < 17) return "Good afternoon";
  if (hour >= 17 && hour < 21) return "Good evening";
  return "Good night";
};

// Pages that keep the greeting instead of showing a title
const GREETING_PAGES = new Set([
  'saas-admin-dashboard',
]);

const PAGE_TITLES = {
  'dashboard':            'Human Resource Dashboard',
  'tasks':                'Tasks',
  'projects':             'Projects',
  'leads':                'Leads',
  'crm-leads':            'Leads',
  'users':                'All Employees',
  'roles':                'Roles',
  'roles/create':         'Create Role',
  'roles/edit':           'Edit Role',
  'users/create':         'Add New Employee',
  'users/:id':            'Edit Employee',
  'departments':          'Departments',
  'designations':         'Designations',
  'employeejob':          'Job Status',
  'companies':            'Companies',
  'packages':             'Packages',
  'modules':              'Modules',
  'saas-admin-users':     'All Users',
  'saas-admin-roles':     'All Roles',
  'permissions':          'Permissions',
  'employee-attendance':  'Employee Attendance',
  'crm-pipeline':         'Pipeline Board',
  'crm-action-queue':     'Action Queue',
  'lead-dashboard':       'Lead Dashboard',
  'secondary-lead-source':'Lead Sources',
  'lead-source':          'Communication Sources',
  'lead-type':            'Lead Interest',
  'prospect_amount':      'Prospect Amount',
  'lead_status':          'Lead Status',
  'lead-settings':        'Lead Settings',
  'leaves':               'Leave Requests',
  'leaves_team':          'Team Leaves',
  'employee_leaves':      'My Leaves',
  'leave_type':           'Leave Types',
  'leaveperiod':          'Leave Period',
  'wfh_hr':               'Work From Home',
  'wfh_approvals':        'WFH Approvals',
  'employee_wfh':         'My WFH',
  'holidays':             'Holidays',
  'attendance':           'Attendance',
  'hr':                   'Attendance',
  'policy':               'HR Policy',
  'settings':             'Settings',
  'priority':             'Priority',
  'ipaddress':            'IP Address',
  'machine-integration':  'Machine Integration',
  'force-checkout-time':  'Force Checkout Time',
  'company_shifts':       'Company Shifts',
  'company_shifts/create': 'Create Company Shift',
  'company_shifts/edit':   'Edit Company Shift',
  'past_days_settings':   'Past Days Settings',
  'performanceperiod':    'Performance Period',
  'performanceweightage': 'Performance Weightage',
  'performanceweightage/create': 'Create Performance Weightage',
  'performanceweightage/:id':    'Edit Performance Weightage',
  'evaluation':           'Performance Evaluation',
  'myevaluation':         'My Evaluation',
  'teamevaluations':      'Team Evaluations',
  'all-users-evaluations':'All Evaluations',
  'chat':                 'Chat',
  'activity-logs':        'Activity Logs',
  'inbox':                'Inbox',
  'notes':                'Notes',
  'meetings':             'Meetings',
  'meetings/:id':         'Meetings',
  'session-management':         'Session Management',
  'app-landing':                'App Landing',
  'task-scheduling-settings':   'Task Scheduling Settings',
  'hire':                 'Recruitment',
};

const PAGE_SUBTITLES = {
  'dashboard':            'Your workspace at a glance',
  'tasks':                'Assign tasks, track progress, and boost productivity.',
  'projects':             'Plan, organize, and deliver projects — all in one workspace.',
  'leads':                'Track and manage your leads pipeline',
  'crm-leads':            'Track and manage your leads pipeline',
  'users':                'Manage your organization\'s employees',
  'roles':                'Define and manage user roles',
  'roles/create':         'Set up a new role and assign permissions',
  'roles/edit':           'Modify role name and update permissions',
  'users/create':         'Fill in the details to add a new employee',
  'users/:id':            'Update employee information and access',
  'departments':          'Organize your company departments',
  'designations':         'Manage employee designations',
  'employeejob':          'Manage employee job statuses',
  'companies':            'Manage registered companies',
  'packages':             'Manage subscription packages',
  'modules':              'Manage system modules',
  'saas-admin-users':     'Manage all registered users',
  'saas-admin-roles':     'Manage roles and their permissions',
  'permissions':          'Configure system permissions',
  'employee-attendance':  'Track employee attendance records',
  'crm-pipeline':         'Manage and track your leads through the sales pipeline',
  'crm-action-queue':     'Prioritize and act on pending items',
  'lead-dashboard':       'How are the leads performing?',
  'secondary-lead-source':'Manage your lead sources',
  'lead-source':          'Configure communication sources',
  'lead-type':            'Define your lead interest categories',
  'prospect_amount':      'Set and manage prospect amounts',
  'lead_status':          'Configure lead status options',
  'lead-settings':        'Customize your lead management settings',
  'app-landing':          'Manage app landing screen content',
  'leaves':               'Review and manage employee leave requests',
  'leaves_team':          'Monitor your team\'s leave requests',
  'employee_leaves':      'View and apply for your leaves',
  'leave_type':           'Configure leave types and policies',
  'leaveperiod':          'Set leave periods for your organization',
  'wfh_hr':               'Manage work from home requests',
  'wfh_approvals':        'Review and approve WFH requests',
  'employee_wfh':         'View and apply for work from home',
  'holidays':             'Manage public and company holidays',
  'attendance':           'Monitor employee attendance records',
  'hr':                   'Track your daily attendance',
  'policy':               'Manage and share company policies',
  'settings':             'Configure your workspace settings',
  'priority':             'Manage task priority levels',
  'ipaddress':            'Manage allowed IP addresses',
  'machine-integration':  'Integrate attendance machines',
  'force-checkout-time':  'Set automatic checkout rules',
  'company_shifts':       'Manage employee shift schedules',
  'company_shifts/create': 'Set up a new shift schedule',
  'company_shifts/edit':   'Update shift schedule details',
  'past_days_settings':   'Configure past days editing rules',
  'performanceperiod':    'Define performance review periods',
  'performanceweightage': 'Set KPI weights for evaluations',
  'performanceweightage/create': 'Set KPI weights for evaluations',
  'performanceweightage/:id':    'Set KPI weights for evaluations',
  'evaluation':           'Calculate and submit employee performance scores for the current period.',
  'myevaluation':         'Track and review your performance',
  'teamevaluations':      'Review your team\'s evaluations',
  'all-users-evaluations':'View evaluations across all employees',
  'chat':                 'Communicate and collaborate with your team',
  'activity-logs':        'Track all system activity and changes',
  'inbox':                'All your notifications in one place — tasks, mentions, comments, and messages.',
  'notes':                'Capture your thoughts and ideas, and find them again when you need them.',
  'meetings':             'Plan meetings, run them from the agenda and keep track of the tasks discussed.',
  'meetings/:id':         'Plan meetings, run them from the agenda and keep track of the tasks discussed.',
  'session-management':         'Monitor and manage active user sessions',
  'hire':                       'Manage job vacancies and applicants',
  'task-scheduling-settings':   'Configure notification thresholds for the Advanced Task Scheduling Engine',
};

const Header = (props) => {
  const [userPermissions, setuserPermissions] = useState([]);
  const location = useLocation();

  // Extract the page segment — try index 0 first (for non-cid routes), fall back to index 1
  const pathParts = location.pathname.split('/').filter(Boolean);
  const firstPart = pathParts[0] || '';
  const secondPart = pathParts[1] || '';
  const isKnownPage = PAGE_TITLES[firstPart] || PAGE_SUBTITLES[firstPart] || GREETING_PAGES.has(firstPart);
  const pageSegment = isKnownPage ? firstPart : secondPart;
  const subSegment = isKnownPage ? secondPart : (pathParts[2] || '');
  const normalisedSub = /^\d+$/.test(subSegment) ? ':id' : subSegment;
  const compoundKey = normalisedSub ? `${pageSegment}/${normalisedSub}` : pageSegment;
  const isSaasAdmin = pageSegment.startsWith("saas-admin");
  const showGreeting = GREETING_PAGES.has(pageSegment);
  const pageTitle = PAGE_TITLES[compoundKey] || PAGE_TITLES[pageSegment] || null;
  const pageSubtitle = PAGE_SUBTITLES[compoundKey] || PAGE_SUBTITLES[pageSegment] || null;

  useEffect(() => {
    const upermission = DataParser.CompanyUserPermissions();
    setuserPermissions(upermission);
  }, []);

  const navigate = useNavigate();
  const username = DataParser.CompanyUserName();
  const userImage = DataParser.CompanyUserImage();

  // const handelLogout = (e) => {
  //   e.preventDefault();
  //   secureLocalStorage.clear();
  //   navigate("/");
  // };

  const handelLogout = (e) => {
    e.preventDefault();
    LoginService.logout();
    navigate("/");
  };

  const handelEditItem = (e) => {
    e.preventDefault();
    const id = DataParser.UserId();
    navigate(`/${DataParser.CompanyIdentifierRole()}/users/${id}`);
  };

  // the one profile item: with "user-edit" the whole record can be changed (the employee edit page, own
  // record); without it, the profile page, where only the password, the picture and two-factor change
  const handelViewProfile = (e) => {
    e.preventDefault();
    if (userPermissions.indexOf("user-edit") !== -1) handelEditItem(e);
    else navigate(`/${DataParser.CompanyIdentifierRole()}/profile`);
  };

  return (
    <>
      <NotificationBanner />
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex align-items-center" style={{  paddingTop: "4px" }}>
            <div style={{ lineHeight: 1.2 }}>
              {showGreeting || !pageTitle ? (
                <>
                  <div style={{ fontSize: "clamp(18px, 5vw, 22px)", fontWeight: 600, color: "#1D1D1D" }}>
                    {getGreeting()}, {username}!
                  </div>
                  <div style={{ fontSize: "clamp(11px, 3vw, 13px)", color: "#787878", marginTop: "2px" }}>
                    Let’s make today productive!
                  </div>
                </>
              ) : (
                <>
                  <div style={{ fontSize: "clamp(18px, 5vw, 22px)", fontWeight: 600, color: "#1D1D1D" }}>
                    {pageTitle}
                  </div>
                  {pageSubtitle && (
                    <div style={{ fontSize: "clamp(11px, 3vw, 13px)", color: "#787878", marginTop: "2px" }}>
                      {pageSubtitle}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                type="button"
                className="btn header-item noti-icon waves-effect"
                id="page-header-search-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="uil-search" />
              </button>
              <div
                className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {/* {compId > 0 && userPermissions.indexOf("tasks-create") !== -1 ? (
              <div className="dropdown d-none d-lg-inline-block ms-1 mr-4">
                <button
                  type="button"
                  className="btn padding header-item noti-icon waves-effect"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <div className="plus-icon green-background iconstyle mr-4">
                    <FaPlus />
                  </div>
                </button>
                <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end w-100">
                  <div className="row g-0">
                    <div className="col">
                      <Link
                        className="dropdown-item"
                        onClick={(e) => goToTasks(e)}
                        to="#"
                      >
                        <i className="uil-list-ul" /> &nbsp;
                        <span>Tasks</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ) : null} */}


            {!isSaasAdmin && <QuickNote />}
            {!isSaasAdmin && <OpenMeetingReminder />}
            {!isSaasAdmin && <MeetingOverrunPrompt />}
            {!isSaasAdmin && <Notofication />}

            <div className="dropdown d-inline-block" style={{ position: "relative" }}>
              <button
                type="button"
                className="btn padding header-item waves-effect dropdown-toggle"
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <UserProfile username={username} userImage={userImage} style={{ width: "26px", height: "26px" }} bgColor="#000000" preview={false} />
                <i className="uil-angle-down d-none d-xl-inline-block font-size-15 ms-1" />
              </button>
              <div
                className="dropdown-menu dropdown-menu-end profileeeeee   "
                aria-labelledby="page-header-user-dropdown"
              >
                {/* Every company user's own profile: all of it with "user-edit", otherwise password, picture and 2FA */}
                {!DataParser.IsSaaSAdmin() && (
                  <Link
                    className="dropdown-item"
                    to="#"
                    onClick={(e) => handelViewProfile(e)}
                  >
                    <i className="uil uil-eye font-size-18 align-middle text-muted me-1" />
                    <span className="align-middle">View Profile</span>
                  </Link>
                )}
                <Link
                  className="dropdown-item"
                  onClick={(e) => handelLogout(e)}
                  to="#"
                >
                  <i className="uil uil-sign-out-alt font-size-18 align-middle me-1 text-muted" />
                  <span className="align-middle">Sign out</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
